<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-icon" *ngIf="!isConnection">
        <i class="material-icons">portable_wifi_off</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="refreshPage()">
        <i class="material-icons">refresh</i>
      </div>
      <div *ngIf="filtersApplied" class="ir-btn th-btn-search" (click)="resetFilters()">
        <i class="material-icons">filter_alt_off</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()" *ngIf="isConnection">
        <i class="material-icons">search</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="exportInspections()" *ngIf="isConnection">
        <i class="material-icons">file_download</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="openMenu()" *ngIf="isConnection">
        <i class="material-icons">more_vert</i>
      </div>
    </div>
    <div class="ir-line-content">
      <span
        >{{ inspectionsLabel | translate }} <strong>({{ inspections?.length }})</strong></span
      >
    </div>
  </div>
  <inspection-filter-component
    *ngIf="isConnection && showSearch"
    [filter]="filter"
    (toggleClose)="updateShowSearch(false)"
    (openFilter)="openFilters()"
    (toggleSearch)="applyFilters()"
    (resetFilters)="resetFilters()"
  ></inspection-filter-component>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <ng-container *ngIf="!isIntallation; else installationList">
    <inspection-list-table
      [inspections]="inspections"
      [orderBy]="filter.order"
      (toggleSort)="sort($event)"
      (toggleScroll)="loadNextPage()"
      (toggleSelectInspection)="openInspection($event)"
      (toggleReport)="viewReport($event)"
    ></inspection-list-table>
  </ng-container>
  <ng-template #installationList>
    <installation-list-table
      [inspections]="inspections"
      [orderBy]="filter.order"
      (toggleSort)="sort($event)"
      (toggleScroll)="loadNextPage()"
      (toggleSelectInspection)="openInspection($event)"
      (toggleReport)="viewReport($event)"
    >
    </installation-list-table>
  </ng-template>
</div>

<modal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="applyFilters()" #filterModal></modal>
